import { Epic } from "redux-observable";
import { from, of } from "rxjs";
import { filter, switchMap, map, catchError, debounceTime } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";

import { RootAction } from "../../store/rootAction";
import { RootState } from "../../store/rootReducer";
import { ApiClient } from "../../lib/api";
import { fetchOrdersAsync, searchOrdersAsync } from "./actions";

export const fetchOrdersEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  ApiClient
> = (action$, state$, client) => 
  action$.pipe(
    filter(isActionOf(fetchOrdersAsync.request)),
    switchMap(action => from(client.fetchOrders(action.payload.filter, action.payload.after))
      .pipe(map(fetchOrdersAsync.success), 
        catchError((error: Error) => of(fetchOrdersAsync.failure(error)))
      )
    )
  );


export const searchOrdersEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  ApiClient
  > = (action$, state$, client) => 
  action$.pipe(
    filter(isActionOf(searchOrdersAsync.request)),
    debounceTime(1000),
    switchMap(action =>
      from(client.searchOrders(action.payload))
      .pipe(map(searchOrdersAsync.success), 
        catchError((error: Error) => of(searchOrdersAsync.failure(error)))
      )
    )
  );
